import type { ApolloClient, QueryOptions } from "@apollo/client";

/**
 * Wraps ApolloClient.query in a Promise that resolves to data or rejects on error.
 * Apollo v4 may return { data, error } without throwing; network failures still reject.
 */
export function runClientQueryAsPromise(
  client: ApolloClient,
  queryOptions: QueryOptions
): Promise<unknown> {
  return client.query(queryOptions).then(({ data, error }) => {
    if (error) {
      return Promise.reject(error);
    }
    return data;
  });
}
